import { useState, useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ZoomIn, ZoomOut, RotateCcw, ExternalLink, FileText } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const fileUrl = (fid) => `${BACKEND}/api/files/${fid}`;

export default function FileViewer({ open, onClose, fileId, fileKind, title }) {
  const [scale, setScale] = useState(1);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const drag = useRef(null);
  const url = fileId ? fileUrl(fileId) : null;
  const reset = () => { setScale(1); setPos({ x: 0, y: 0 }); };

  const onDown = (e) => { drag.current = { x: e.clientX - pos.x, y: e.clientY - pos.y }; };
  const onMove = (e) => { if (!drag.current) return; setPos({ x: e.clientX - drag.current.x, y: e.clientY - drag.current.y }); };
  const onUp = () => { drag.current = null; };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { reset(); onClose(); } }}>
      <DialogContent className="bg-[#0B0B0F] border-white/10 max-w-4xl" data-testid="file-viewer">
        <DialogHeader><DialogTitle className="truncate">{title || "Arquivo"}</DialogTitle></DialogHeader>
        {fileKind === "image" && (
          <div>
            <div className="flex gap-2 mb-2">
              <Button size="sm" variant="outline" onClick={() => setScale((s) => Math.min(s + 0.25, 4))} className="rounded-sm bg-transparent border-white/10 gap-1"><ZoomIn className="h-4 w-4" />Ampliar</Button>
              <Button size="sm" variant="outline" onClick={() => setScale((s) => Math.max(s - 0.25, 0.5))} className="rounded-sm bg-transparent border-white/10 gap-1"><ZoomOut className="h-4 w-4" />Reduzir</Button>
              <Button size="sm" variant="outline" onClick={reset} className="rounded-sm bg-transparent border-white/10 gap-1"><RotateCcw className="h-4 w-4" />Redefinir</Button>
            </div>
            <div className="h-[65vh] overflow-hidden bg-black rounded-sm flex items-center justify-center" onMouseMove={onMove} onMouseUp={onUp} onMouseLeave={onUp}>
              <img data-testid="viewer-image" src={url} alt={title} draggable={false} onMouseDown={onDown}
                style={{ transform: `translate(${pos.x}px, ${pos.y}px) scale(${scale})`, cursor: scale > 1 ? "grab" : "default", transition: drag.current ? "none" : "transform 0.15s" }}
                className="max-h-full max-w-full object-contain select-none" />
            </div>
          </div>
        )}
        {fileKind === "pdf" && (
          <iframe data-testid="viewer-pdf" title={title} src={url} className="w-full h-[70vh] rounded-sm bg-white" />
        )}
        {fileKind === "word" && (
          <div className="py-10 text-center space-y-4">
            <FileText className="h-12 w-12 text-[#00F0FF] mx-auto" />
            <p className="text-zinc-400 text-sm">A visualização de documentos Word não é suportada no navegador.</p>
            <a href={url} target="_blank" rel="noreferrer"><Button className="bg-[#FF4D00] hover:bg-[#E64500] rounded-sm gap-2" data-testid="viewer-word-open"><ExternalLink className="h-4 w-4" />Abrir documento</Button></a>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
